<div class="modal-header">
  <h4 class="modal-title">
    {{ "user.import.title" | translate }}
  </h4>

  <button
    type="button"
    class="close"
    [disabled]="loading"
    (click)="activeModal.dismiss()"
  >
    &times;
  </button>
</div>

<div
  class="modal-body"
  style="display: grid"
>
  <button
    type="button"
    class="custom-btn custom-btn--black"
    style="margin-bottom: 2rem"
    [disabled]="loading"
    (click)="downloadTemplate()"
  >
    {{
      "user.import.download-template"
        | translate
    }}
  </button>

  <input
    #fileInput
    type="file"
    accept=".xlsx,.xls,.csv"
    [disabled]="loading"
    (change)="onFileSelected($event)"
  />
</div>

<div class="modal-footer">
  <button
    type="button"
    class="custom-btn"
    [disabled]="!selectedFile || loading"
    (click)="importUsers()"
  >
    {{
      loading
        ? ("user.import.importing" | translate)
        : ("user.import.import" | translate)
    }}
  </button>
</div>